module.exports = __webpack_public_path__ + "static/img/16.e5b602f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/16.jpg
// module id = JWaO
// module chunks = 1